import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AppWrapper from '../../shared/appWrapper';
import MapView from './components/map-view';
import ItineraryView from './components/itinerary-view';
import CalendarView from './components/calender-view';
import Spinner from '../../shared/spinner';
import { FetchIntineraries } from '../../../actions/itineraries';
import PriceSummary from '../components/price-summary';
import dayjs from 'dayjs';
const queryString = require('query-string');
const qs = queryString.parse(window.location.search);



class Details extends PureComponent {

  constructor(props){
    super(props);
    this.state = {
      calenderActive:false,
      mapActive:false,
      itineraryActive:true
    }
    this.toggleViews = this.toggleViews.bind(this);
    this.onBackClicked = this.onBackClicked.bind(this);

  }

  onBackClicked(){

    const {
      history
    } = this.props;

    history.push(`${process.env.REACT_APP_ITINERARY_PAGE}?id=${qs.id}`);

  }

  componentDidMount(){

    const {
      FetchIntineraries,
      itineraries
    } = this.props;

    // Scroll window to top
    window.scrollTo(0, 0);

    //FetchIntineraries
    if(itineraries === undefined) FetchIntineraries(qs.id);


    this.toggleViews(queryString.parse(window.location.search).v);
  }


  toggleViews(view){
    switch (view) {
      case 'calendar':
        this.setState({ calenderActive:true, mapActive:false, itineraryActive:false});
        break;
      case 'map':
        this.setState({calenderActive:false, mapActive:true, itineraryActive:false});
        break;
      case 'itinerary':
        this.setState({calenderActive:false, mapActive:false, itineraryActive:true});
        break;
      default:
        this.setState({calenderActive:false, mapActive:false, itineraryActive:true});
    }
  }


  render(){

    const { calenderActive, mapActive, itineraryActive } = this.state;
    const { itineraries } = this.props;
    const _itineraries = (itineraries !== undefined && Object.keys(itineraries).length > 0) ? itineraries : [];



    if(_itineraries.length === 0){
      return <Spinner text="Loading your adventure..." loadClass="orange-spinner-wrapper" />
    }else{

      const { itineraries, itineraries:{sectors, content:{date_start, date_end, nr_pax, nr_days, nr_stops, nr_cities}}} = this.props;

      return (
        <Fragment>
          <button className="lity-close" onClick={this.onBackClicked}>×</button>
          <AppWrapper className="details">
            <div className="row text-center margin-t-70">
              <div className="column small-12">

                <ul className="details-menu">
                  <li onClick={e => this.toggleViews('calendar')} className={`${calenderActive  ? 'active' : ''}`}>Calendar</li>
                  <li onClick={e => this.toggleViews('map')} className={`${mapActive  ? 'active' : ''}`}>Map view</li>
                  <li onClick={e => this.toggleViews('itinerary')} className={`${itineraryActive ? 'active' : ''} `}>Itinerary</li>
                </ul>

              </div>
            </div>

            <div className="row margin-t-40">
              <div className="column small-12">
                <h5 className="busabout-h5">{sectors[0].name} to {sectors[sectors.length-1].name}</h5>
              </div>
              <div className="column small-12">
                <p className="display-line">
                  {dayjs(date_start).format('DD MMMM YYYY')}
                  <span className="orange-text">&nbsp; &rarr; &nbsp;</span>
                  {dayjs(date_end).format('DD MMMM YYYY')}
                </p>
                <ul className="details-extra">
                  <li>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="user-svg">
                      <path d="M96 160a160 160 0 1 1 320 0 160 160 0 0 1-320 0zm304 192h-28.6a224 224 0 0 1-230.8 0H112A112 112 0 0 0 0 464v24a24 24 0 0 0 24 24h464a24 24 0 0 0 24-24v-24a112 112 0 0 0-112-112z"/>
                    </svg>
                    x {nr_pax}
                  </li>
                  <li>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="days-svg">
                      <path d="M274.8 12.6L300.4 75a18 18 0 0 0 26 8.5l57.4-35.4a20.3 20.3 0 0 1 30.5 22l-16 65.6a18 18 0 0 0 16.1 22.2l67.2 5a20.3 20.3 0 0 1 11.7 35.8l-51.5 43.6a18 18 0 0 0 0 27.4l51.5 43.6a20.3 20.3 0 0 1-11.7 35.8l-67.2 5a18 18 0 0 0-16.2 22.2l16 65.5a20.3 20.3 0 0 1-30.4 22.1l-57.3-35.4a18 18 0 0 0-26.1 8.5l-25.6 62.4a20.3 20.3 0 0 1-37.6 0L211.6 437a18 18 0 0 0-26-8.5l-57.4 35.4a20.3 20.3 0 0 1-30.5-22l16-65.6a18 18 0 0 0-16.1-22.2l-67.2-5a20.3 20.3 0 0 1-11.7-35.8l51.5-43.6a18 18 0 0 0 0-27.4l-51.5-43.6A20.3 20.3 0 0 1 30.4 163l67.2-5a18 18 0 0 0 16.2-22.2l-16-65.5A20.3 20.3 0 0 1 128.1 48l57.3 35.4a18 18 0 0 0 26.1-8.5l25.6-62.4a20.3 20.3 0 0 1 37.6 0zM392 256c0-75-61-136-136-136s-136 61-136 136 61 136 136 136 136-61 136-136zm-32 0a104.1 104.1 0 0 1-208 0 104.1 104.1 0 0 1 208 0z"/>
                    </svg>
                    {nr_days + 1} days
                  </li>
                  <li>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" className="city-svg">
                      <path d="M172.3 501.7C27 291 0 269.4 0 192a192 192 0 1 1 384 0c0 77.4-27 99-172.3 309.7a24 24 0 0 1-39.4 0zM192 272a80 80 0 1 0 0-160 80 80 0 0 0 0 160z"/>
                    </svg>
                    {nr_cities} cities
                  </li>
                  <li>
                    <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" className="coach-svg">
                      <g fill="#F60" fillRule="nonzero">
                        <path d="M9.5 16.2a43 43 0 0 1-5.2-.3c-1-.1-1.6-.9-1.6-1.8v-10C2.7 2 4.6 0 6.9 0H12c2.3 0 4.2 1.9 4.2 4.2v10c0 .8-.7 1.6-1.6 1.7a43 43 0 0 1-5.1.3zM6.9 1a3.2 3.2 0 0 0-3.2 3.2v10c0 .3.3.7.7.7a42 42 0 0 0 10.1 0c.4 0 .7-.4.7-.8v-10C15.2 2.5 13.8 1 12 1H7z"/>
                        <path d="M3.2 3.6c-.3 0-.5-.2-.5-.4 0-.3.2-.5.5-.5h12.5c.3 0 .5.2.5.4 0 .3-.2.5-.5.5H3.2zM15.7 9.9H3.2c-.3 0-.5-.2-.5-.5 0-.2.2-.4.5-.4h12.5c.3 0 .5.2.5.4 0 .3-.2.5-.5.5zM6.8 18h-1c-.7 0-1.3-.5-1.3-1v-1.3c0-.1 0-.2.2-.3l.3-.1 2.6.2c.3 0 .5.2.5.4v1c0 .6-.6 1.1-1.3 1.1zm-1.3-1.8v.7c0 .2.2.3.3.3h1c.1 0 .3-.1.3-.3v-.6l-1.6-.1zM13 18h-.9c-.7 0-1.3-.6-1.3-1.4v-1.4c0-.2.2-.5.5-.5l2.5-.3.4.1.2.4v1.7c0 .8-.6 1.4-1.3 1.4zm-1.2-2.3v.9c0 .2.2.3.3.3h1c.1 0 .3-.1.3-.3v-1l-1.6.1zM11.2 11.7H7.7c-.3 0-.5-.2-.5-.4 0-.3.2-.5.5-.5h3.5c.3 0 .5.2.5.4 0 .3-.2.5-.5.5zM11.2 13.5H7.7c-.3 0-.5-.2-.5-.4 0-.3.2-.5.5-.5h3.5c.3 0 .5.2.5.5 0 .2-.2.4-.5.4zM11.2 2.7H7.7c-.3 0-.5-.2-.5-.5 0-.2.2-.4.5-.4h3.5c.3 0 .5.2.5.4 0 .3-.2.5-.5.5z"/>
                        <path d="M17.5 5.4a.5.5 0 0 1-.5-.5 1 1 0 0 0-.4-.8c-.7-.5-1.6-.4-1.6-.4a.5.5 0 0 1-.6-.4c0-.3.2-.5.4-.6.1 0 1.4-.2 2.4.6.5.4.8 1 .8 1.6 0 .3-.2.5-.5.5z"/>
                        <path d="M17.6 8.1h-.5c-.5 0-.9-.6-.9-1.3V5c0-.3.2-.5.4-.5h1c.2 0 .4.2.4.5v2.6c0 .3-.2.5-.4.5zM17 5.6v1.2l.1.2h.1V5.6H17zM.5 5.4a.5.5 0 0 1-.5-.5c0-.6.3-1.2.8-1.6 1-.8 2.3-.6 2.4-.6.2 0 .4.3.4.6s-.3.5-.6.5c0 0-1-.2-1.6.3A1 1 0 0 0 1 5c0 .3-.2.5-.5.5z"/>
                        <path d="M.9 8.1H.4c-.2 0-.4-.2-.4-.5V5c0-.3.2-.5.4-.5h1c.2 0 .4.2.4.5v1.8c0 .7-.4 1.3-1 1.3zm-.1-1l.2-.3V5.6H.8V7zM5 13.5H3.2c-.3 0-.5-.2-.5-.5v-1.7c0-.3.2-.5.5-.5H5c.7 0 1.3.5 1.3 1v.6c0 .6-.6 1.1-1.3 1.1zm-1.2-1h1.4v-.6c0-.1 0-.2-.2-.2H3.8v.9zM15.7 13.5h-1.8c-.7 0-1.3-.5-1.3-1v-.6c0-.6.6-1.1 1.3-1.1h1.8c.3 0 .5.2.5.5V13c0 .2 0 .3-.2.4l-.3.1zm-1.8-1.8c-.1 0-.2 0-.2.2v.5c0 .1 0 .2.2.2H15v-.9H14zM12.2 8.1a.5.5 0 1 1 0-1h1.1V5.8a.5.5 0 0 1 1.1 0v1.7c0 .2-.2.5-.5.5h-1.7z"/>
                      </g>
                    </svg>
                    {nr_stops} stops
                  </li>
                </ul>
              </div>
            </div>

            <div className="row margin-t-50">
               <div className="column small-12">
                { mapActive && <MapView itineraries={itineraries} /> }
                { itineraryActive && <ItineraryView /> }
                { calenderActive && <CalendarView /> }
              </div>
            </div>


            <PriceSummary type="payment" />

          </AppWrapper>
        </Fragment>
      )
    }
  }

}



function mapStateToProps(state){
  return {
    itineraries:state.itineraries.data
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    FetchIntineraries
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(Details);



// WEBPACK FOOTER //
// ./src/components/itinerary/details/index.js